<template>
	<div class="row align-center space-center text-center div-all">
		<div class="div-cont">
			<img src="./../assets/images/locktip.png"/>
			<h3>{{$t('components.maskLayerPageLocked')}}</h3>
      <template v-if="1===2">
        <p>{{$t('components.maskLayerUnlockTip')}}</p>
        <div class="row align-center">
          <img src="./../assets/images/lockpaw.png"/>
          <input ref="pasInput" type="password" v-model="unLockPassword" :placeholder="$t('components.maskLayerEnterPassword')" @keyup.enter="sureUnlock"/>
        </div>
        <el-button class="button" type="primary" size="small" @click="sureUnlock">{{$t('components.maskLayerConfirm')}}</el-button>
      </template>

      <div class="normal-box" @click="unlockHandel('normal')"></div>
      <el-button class="button" type="primary" size="small" @click="unlockHandel('hide')">{{$t('components.maskLayerClickToUnlock')}}</el-button>
		</div>
	</div>
</template>

<script>
import {ipc} from "@/utils/ipcRenderer";
import {ipcApiRoute, specialIpcRoute} from "@/api/main";
import {queryMarketFakeInfo} from "@/libs/http/modules/posOrder";

export default {
	name: 'mask-layer',
	data() {
		return {
			unLockPassword: '',
      originalPwd: '0000',
      proportionPwd: '8888'
		}
	},
  created() {
    // this.fetchPassword()
    // this.$nextTick(()=>{
    //   this.$refs.pasInput.focus()
    // })
  },
  methods: {
    fetchPassword(){
      queryMarketFakeInfo().then(res=>{
        if(res){
          this.originalPwd = res.originalPwd
          this.proportionPwd = res.proportionPwd
        }
      }).catch(error=>{})
    },
		sureUnlock() {
			if (!this.unLockPassword){
				return this.$message({type: "error", message: this.$t('components.maskLayerEnterUnlockPwd'), duration: 2000, showClose: true})
			}
			if((this.unLockPassword !== this.originalPwd) && (this.unLockPassword !== this.proportionPwd)){
				return this.$message({type: "error", message: this.$t('components.maskLayerCorrectUnlockPwd'), duration: 2000, showClose: true})
			}
			if(this.unLockPassword === this.proportionPwd){
				this.$cache.local.set('isRevenue', 'Y')
			}else{
				this.$cache.local.set('isRevenue', 'N')
			}
			ipc.invoke(ipcApiRoute.getWCid, 'main').then(id => {
				let mainWCid = id
				if (mainWCid) {
					ipc.sendTo(mainWCid, specialIpcRoute.window2ToWindow1, 'unLockPage')
				}
			})
		},
    unlockHandel(type){
      if(type === 'normal'){
        this.$cache.local.set('isRevenue', 'N')
      }else{
        this.$cache.local.set('isRevenue', 'Y')
      }
      ipc.invoke(ipcApiRoute.getWCid, 'main').then(id => {
        let mainWCid = id
        if (mainWCid) {
          ipc.sendTo(mainWCid, specialIpcRoute.window2ToWindow1, 'unLockPage')
        }
      })
    }
	}
}
</script>

<style lang="scss" scoped>
.div-all {
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 9999;
	width: 100vw;
	height: 100vh;
	overflow: hidden;
	background-image: url("./../assets/images/lockbg.png");
	background-size: cover;
	
	.div-cont {
		width: 300px;
		background: #fff;
		border-radius: 10px;
		padding: 20px;
		
		> img {
			width: 40px;
			height: 40px;
			border-radius: 50%;
			background: #eee;
			margin-bottom: 15px;
		}
		
		p {
			color: #999;
			margin: 10px auto 25px;
			font-size: 14px;
		}
		
		div {
			background: #F6F7FB;
			height: 36px;
			line-height: 36px;
			
			input {
				outline: none;
				background: none;
				width: 200px;
				height: 36px;
				margin-left: 10px;
				border: none;
			}
			
			img {
				width: 20px;
				margin-left: 5px;
				float: left;
			}
		}
		
		.button {
			width: 200px;
			background: #067CF2;
			margin-top: 40px;
			height: 40px;
			font-size: 16px;
		}

    .normal-box{
      position: fixed;
      top: 13%;
      left: 26%;
      width: 300px;
      height: 130px;
      cursor: pointer;
      background: none;
      transform: translate(-50%, -50%);
    }
	}
}
</style>